import script from "./UIExplain.vue?vue&type=script&setup=true&lang=ts"
export * from "./UIExplain.vue?vue&type=script&setup=true&lang=ts"

import "./UIExplain.vue?vue&type=style&index=0&id=302179d9&lang=css"

const __exports__ = script;

export default __exports__